import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const testimonials = [{
  image: 'https://cdn.magicpatterns.com/uploads/6woGoZZ58PZurSZ7Y9FmxV/subway-welcome.jpg',
  imageAlt: 'Subway Kent — AccuTemp commercial HVAC installation',
  quote: "AccuTemp's in-house team resolved our cooling issues in days, not the weeks we'd been quoted elsewhere. Their service reports are the most thorough we've seen.",
  name: 'James Mitchell',
  role: 'Facilities Manager, Coventry Retail Park',
  caseStudyLink: '/case-studies/subway'
}];
export function Testimonial() {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % testimonials.length);
    }, 10000);
    return () => clearInterval(interval);
  }, []);
  const testimonial = testimonials[current];
  return <section id="case-studies" className="py-16 lg:py-24 px-4 md:px-6" data-id="element-667">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="w-[95%] mx-auto bg-primary-dark rounded-3xl overflow-hidden relative" data-id="element-668">
        <div className="grid lg:grid-cols-2 min-h-[500px]" data-id="element-669">
          {/* Left — Image */}
          <div className="relative h-72 lg:h-auto overflow-hidden" data-id="element-670">
            <AnimatePresence mode="wait" data-id="element-671">
              <motion.img key={current} src={testimonial.image} alt={testimonial.imageAlt} className="absolute inset-0 w-full h-full object-cover" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.8
            }} data-id="element-672" />
            </AnimatePresence>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-primary-dark/30 hidden lg:block" data-id="element-673"></div>
          </div>

          {/* Right — Quote */}
          <div className="relative flex flex-col justify-center p-10 md:p-14 lg:p-16" data-id="element-674">
            {/* Large decorative quote mark */}
            <div className="text-[220px] md:text-[280px] leading-none font-serif text-accent/10 select-none absolute -top-16 -left-4 pointer-events-none" data-id="element-675">
              &ldquo;
            </div>

            <div className="relative z-10" data-id="element-676">
              <span className="text-xs uppercase tracking-[0.2em] font-medium text-accent mb-8 block" data-id="element-677">
                What our clients say
              </span>

              <AnimatePresence mode="wait" data-id="element-678">
                <motion.div key={current} initial={{
                opacity: 0,
                y: 12
              }} animate={{
                opacity: 1,
                y: 0
              }} exit={{
                opacity: 0,
                y: -12
              }} transition={{
                duration: 0.5
              }} data-id="element-679">
                  <blockquote className="text-2xl md:text-3xl lg:text-4xl font-serif text-white leading-[1.5] mb-10 tracking-tight" data-id="element-680">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>

                  <div className="flex items-center gap-5" data-id="element-681">
                    <div className="w-12 h-[2px] bg-accent" data-id="element-682"></div>
                    <div data-id="element-683">
                      <div className="text-white font-medium mb-0.5" data-id="element-684">
                        {testimonial.name}
                      </div>
                      <div className="text-white/50 text-sm" data-id="element-685">
                        {testimonial.role}
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Dot indicators */}
            {testimonials.length > 1 && <div className="absolute bottom-8 left-10 md:left-14 lg:left-16 flex items-center gap-2" data-id="element-686">
                {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrent(idx)} className={`w-2 h-2 rounded-full transition-all duration-300 ${idx === current ? 'bg-accent w-6' : 'bg-white/30 hover:bg-white/50'}`} aria-label={`View testimonial ${idx + 1}`} data-id="element-687" />)}
              </div>}

            {/* Top-right link */}
            <Link to="/case-studies" className="absolute top-8 right-8 md:top-10 md:right-10 hidden md:flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors" data-id="element-688">
              See more stories
              <ArrowRight className="w-4 h-4" data-id="element-689" />
            </Link>
          </div>
        </div>
      </motion.div>
    </section>;
}